import { useEffect } from 'react';
import { isRouteErrorResponse } from 'react-router-dom';
import Card from '~/components/Card';
import Page from '~/components/Page';
import { logError } from '~/utils/observability';
import { useRouteError } from '~/utils/routing';
import { isErrorMessage } from '~/utils/schemas';

export default function ReturnSummaryError() {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      logError(error.message, {
        extra: {
          cause: error.cause,
        },
      });
    }
  }, [error]);

  if (isRouteErrorResponse(error) || !isErrorMessage(error)) {
    throw error;
  }

  return (
    <Page headline="Sorry about that ...">
      <Card>
        We had an issue submitting your request, and are looking into it.
      </Card>
    </Page>
  );
}
